<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>

            <div class="col-md-6">

                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <app-sub-header title="Create Ticket"></app-sub-header>

                            <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                                <div style="min-height: 500px;">
                                    <div class="row">
                                        <div class="col-md-12">


                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <select class="form-control" formControlName="title" id="sel1"
                                                    [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                                                    <option value="">Select Title</option>
                                                    <option *ngFor="let props of tickets" [value]="props.value">
                                                        {{props.name}}
                                                    </option>

                                                </select>
                                                <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.title.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Description</label> -->
                                                <textarea maxlength="1000" class="form-control" formControlName="description"
                                                    placeholder="Description" rows="5"
                                                    [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.description.value?.length || 0}}/1000</p>
                                                </div>
                                                <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.description.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </div>

                                <br>
                                <button type="submit"
                                    class="btn btn-lg btn-block main-backgroundcolor color" style="margin-top: -300px;">Create</button>
                            </form>
                        </div>
                    </div>
                </div>


            </div>

            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
